import React, { useContext } from 'react'
import styles from './UrlField.module.css'
import { BuilderContext } from '../../../store/store.Builder'

const UrlField = ({ field }) => {
  const builderContext = useContext(BuilderContext)

  return <div className={styles.container}></div>
}
export default UrlField
